export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 812;
export const menuHiddenBreakpoint = 812;
export const defaultLocale = 'es';
export const localeOptions = [{ id: 'es', name: 'Espa�ol', direction: 'ltr' }, { id: 'en', name: 'English', direction: 'ltr' }];

export const adminRoot = '/app';
export const searchPath = `${adminRoot}/#`;
export const storagePath = `/formspds`; //Producci�n


//export const servicePath = 'http://localhost:5001/unops-infraigss-prod/us-central1/sigeiinfraigssdev/';  //Local
//export const servicePath = 'https://us-central1-unops-infraigss-prod.cloudfunctions.net/sigeiinfraigssdev/'; //Desarrollo
export const servicePath = 'https://us-central1-unops-infraigss-prod.cloudfunctions.net/sigei/'; //Produccion 


export const currentUser = { id: 1, title: 'No definido', img: '/assets/img/profiles/l-1.jpg', date: 'Last seen today 15:24' }

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.blueyale';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = ['blueyale'];

